@let isConnected = odinService.status() === OdinConnectionStatus.connected;
@let isSetup = appService.showSetupWizard();
@let showPromo = appService.showPromo();
@let section = appStore.activeSection$ | async;
<div
  class="main-nav {{ appStore.loginAreaLogoSize$ | async }} {{
    appStore.getConnectedClass$() | async
  }} {{ section === 'preparation-area' ? 'connected' : '' }}">
  <div class="nav-wrapper">
    <img
      src="{{ (appConfigStore.getAsset$(userSettingsStore.colorMode + 'Logo') | async)?.url }}"
      crossorigin="anonymous" />
    <nav>
      @if (!isConnected && section !== 'preparation-area') {
        @if (isSetup) {
          <button
            (click)="onClickedTab('setup')"
            class="{{ section === 'setup' ? 'active' : '' }} icon-btn">
            <fa-icon [icon]="faRocketLaunch"></fa-icon>
          </button>
        }
        @if (showPromo) {
          <button
            (click)="onClickedTab('show-promo')"
            class="{{ section === 'show-promo' ? 'active' : '' }} icon-btn">
            <fa-icon [icon]="faRocketLaunch"></fa-icon>
          </button>
        }
        @if (!showPromo && !isSetup) {
          <button
            (click)="onClickedTab('room-login')"
            class="{{ section === 'room-login' ? 'active' : '' }} icon-btn">
            <fa-icon [icon]="faHouse"></fa-icon>
          </button>
          <button
            (click)="onClickedTab('sign-in')"
            class="{{ section === 'sign-in' ? 'active' : '' }} icon-btn">
            <fa-icon [icon]="faKey"></fa-icon>
          </button>
          <button
            (click)="onClickedTab('general-settings')"
            class="{{ section === 'general-settings' ? 'active' : '' }} icon-btn">
            <fa-icon [icon]="faSliders"></fa-icon>
          </button>
        }
        <button
          (click)="onClickedTab('about')"
          class="{{ section === 'about' ? 'active' : '' }} icon-btn"
          [attr.aria-label]="'About' | translate">
          <fa-icon [icon]="faInfoCircle"></fa-icon>
        </button>
        <button (click)="userSettingsStore.toggleColorMode()" class="">
          @if ((userSettingsStore.colorMode$ | async) === 'dark') {
            <fa-icon [icon]="faSunBright"></fa-icon>
          } @else {
            <fa-icon [icon]="faMoonStars"></fa-icon>
          }
        </button>
      }
      @if (!isConnected && section === 'preparation-area') {}
    </nav>
  </div>
  <div class="room-info-wrapper">
    @if (isConnected || section === 'preparation-area') {
      <andor-room-info></andor-room-info>
    }
  </div>
</div>
